<template>
  <div class="box">
    <el-container>
      <el-header
        :class="NowPath ? 'isAssume' : isRegister ? 'isResigters' : ''"
      >
        <div class="Header" :class="isRegister ? 'RegisterPage' : ''">
          <div class="Globalcontainer">
            <!-- <img src="../assets/Home/组 23378@2x.png" alt="" /> -->
             <img src="../assets/Home/组 24540@2x (1).png" alt="" />
            <div class="RightContent">
            <div style="width:100%" >
            
              <el-input
                v-show="!isRegister"
                placeholder="输入您想要搜索的内容"
                v-model="input3" style="width: 90%;"
              >
                <el-button
                  slot="append"
                  @click="ToSearch"
                  @keydown.enter.native="ToSearch()"
                  icon="el-icon-search"
                ></el-button
              ></el-input>
            </div>
              <template v-if="RealName == ''" >
                <el-button
                  type="primary"
                  class="RegisterBtn"
                  @click="OpenLogin"
                  size="small"
                  >登录</el-button
                >
                <el-button
                v-show="!isRegister"
                  type="primary"
                  class="RegisterBtn"
                  @click="toRegister"
                  size="small"
                  >注册</el-button
                >
              </template>
              <template v-else>
                <span> 您好!{{ RealName }} </span>

                <el-button
                  type="primary"
                  style="margin-left: 0.625rem"
                  @click="toManage"
                  class="RegisterBtn"
                  size="small"
                  >网上工作室</el-button
                >
                <el-button
                  type="primary"
                  class="RegisterBtn"
                  @click="Logout"
                  size="small"
                  >退出</el-button
                >
              </template>
              <h3 class="ishad" v-if="isRegister" style="cursor: pointer" @click="toIndex">
                返回首页
              </h3>
            </div>
          </div>
        </div>
        <ul v-if="!isRegister">
       
         
          <li
            v-for="(i, n) in paths"
            :key="n"
            @click="FocusNow(n, i)"
            
            :class="n == nowFocus ? 'isFocus' : ''"
            @mouseenter="showSpecialList(i, n)"
            @mouseleave="isShowTrue(nowFocus)"
          >
          <span v-if="n === 1" class="nw" >
        <img
       
                    class="hot"
                    src="../assets/images/igb.png"
                    alt
                  /> </span>
            {{ i.name }}
            <template v-if="n == 8">
              <div v-show="ShowTrue==1?true:false" class="specialList">
                <router-link @click="ShowTrue = 0" to="/contractLogin"
                  >技术合同登记</router-link
                >
                <router-link @click="ShowTrue = 0" to="/scienceLoan"
                  >科技贷</router-link
                >
                   <router-link @click="ShowTrue = false" to="/NewMap"
                >创新地图</router-link
              > 
        
        <router-link @click="ShowTrue = false" to="/AboutPublicity"
                >公示鉴证</router-link
              > 
              <a href="https://www.hnkjfw.cn/zcfwqyzc" target="_blank" @click="ShowTrue = false" 
                >科技分析工具</a
              > 
              </div>
            </template>
            <!-- <template v-if="n == 9">
              <div v-show="ShowTrue==2?true:false" class="specialList1">
                <router-link @click="ShowTrue = 0 ; return false" to=""
                  >政策资讯</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >行业活动</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >合作机构</router-link
                >
                 <router-link @click="ShowTrue = 0" to=""
                  >人才培训</router-link
                >
               
                <router-link @click="ShowTrue = 0" to=""
                  >自创区动态</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >线上直播间</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >全球供需对接</router-link
                >
                <router-link @click="ShowTrue = false" to="/NewMap"
                >创新地图</router-link
              >
              </div>
            </template> -->
          </li>
        </ul>
      </el-header>
      <el-main><router-view /></el-main>
      <el-footer :style="isRegister ? ' margin-top:80.5rem ' : ''">
        <div class="footer1">
          <div class="Globalcontainer" style="width:1500px;padding-top: 3rem;">
            <!-- <img src="../assets/Home/组 23100@2x.png" alt="" /> -->
            <!-- <div style="margin-right: 65px;">
              <span class="guanyu" @click="goAboutUs">关于我们</span>
              <span>|</span>
              <a :href="Urls+'/hebi.html'" target="_blank"
                >鹤壁技术转移中心</a
              >
              <span>|</span>
              <a href="https://www.hkgzyzh.cn/" target="_blank"
                >郑州航空港科技成果转移转化公共服务平台</a
              >
              <span>|</span>
              <a :href="Urls+'/ZGCcement/index.html'" target="_blank"   
                >中关村科技成果转移转化公共服务平台</a
              >
            </div> -->
            <div class="about" style="margin-right:3rem;">
             <div class="tit" style="margin-bottom: 1rem;">关于平台</div>
            <div style="margin-bottom: 0.5rem;"> <router-link to="/callUs">平台简介</router-link></div>
             <!-- <div> <a  target="_blank">联系我们</a></div> -->
              </div>
            <div class="work">
              <div class="tit" style="margin-bottom: 1rem;">建设运营单位</div>
            <div style="margin-bottom: 0.5rem;"> 主管单位：<a href="https://kjt.henan.gov.cn/" target="_blank" style="color:#ADB3B9;"
              >河南省科学技术厅</a></div>
             <div>建设单位：<a href="http://www.hnkczx.com/" target="_blank" style="color:#ADB3B9;"
              >河南省科技创新促进中心</a></div>
            </div>
            <div class="work">
              <div class="tit" style="margin-bottom: 1rem;">服务热线</div>
            <div style="margin-bottom: 0.5rem;"> 电话：0371-67579156 </div>
             <div>(周一至周五 9:00-18:00)</div>
            </div>
            <div class="ewm" style="margin-top: -3rem;">
              <div class="guanzu" style="color:#ADB3B9;width: 10rem;margin-right:1.2rem;">
              <img
                style="width: 4.25rem; margin-bottom: 0.375rem"
                src="../assets/images/图像 289@2x.jpg"
                alt=""
              />
              <br />
              科技成果转移转化平台
            </div>
            </div>
            <div class="ewm" style="margin-top: -3rem;">
              <div class="guanzu" style="color:#ADB3B9;width: 10rem;margin-right: 0.2rem;">
              <img
                style="width: 4.25rem; margin-bottom: 0.375rem"
                src="../assets/images/图像 288@2x.png"
                alt=""
              />
              <br />
              科技企业公共服务平台
            </div>
            </div>
            <div class="ewm" style="margin-top: -3rem;margin-right: 2rem;">
              <div class="guanzu" style="color:#ADB3B9;width: 10rem;">
              <img
                style="width: 4.25rem; margin-bottom: 0.375rem"
                src="../assets/images/图像 290@2x.png"
                alt=""
              />
              <br />
              跨国技术转移大会
            </div>
            </div>
            <div class="logoo" style="margin-top: -2rem;">
              <img
                style="width:16rem;"
                src="../assets/images/bottom_tips_icon.bba70565@2x.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="footer2">
          <div class="Globalcontainer">
            <div style="margin-left: 10rem;margin-top: 1.5rem;">技术支持： 河南八六三软件股份有限公司</div>
            <div  style="margin-top: 1.5rem;"> 版权所有©2024 nttzzc.cn</div>
            <div  style="margin-top: 1.5rem;"><a href="https://beian.miit.gov.cn/" style="color:#ADB3B9;">豫ICP备2024064350号-5</a></div>
            <div style="margin-top: 1.5rem;">
              <img style="width: 18px; height: 20px;margin-right: 5px;" src="data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAFQklEQVRYw+3Wa1BUdRjH8SOpMeg4WhZGpDIxiaaTeUFgWrxE4AVRQJGlRRAVIV1JkbgMgQLi5AVBQSVLSp0xlEAUKBEEFZCrCstll8UV2AV2YbmoGCrYv31+R95UL5pmmtamZ+bz6rz5nvOc/5zDcX9jGLs/iTxuyvIlWYkRFeTHA2HVRFtzfhthTG5KuH96/vUgNlC4mMgyw1NJit/aAXLKazYje9xtIMZ/OZz50gW+9hcNkvoLEemEPbnrSP47QYwxQ5Ifv54RqzcXwFFvSyjaOhfavN8F7Y5ZcC/HH9JOB4LNa9Zw5YA76OZV8vIGMdZtSp7cDrtOnOavYiQhTAiPwi1AMtIQaqyngsxpBtw2GAGDKfaQmpUAa6xc4Vfp4UtEdzAMycsT9JQ1Tyctl/2eEkuTlYysF/rCUNxMqDEzgTqzSXBnpgnIHCzgjvEEuD52DLBr3rA1MAaWmNtB582wdtIljZ9G9D+IPU6aTxIPBjHCcXvg3CEh9K2fDLWvjIH6D6fwTIyheuwEqLUyhzLOALq8pkN+bgRw3HY4FBsMzxojZxP9DequLjAlQwVrbpIjhyIY4UYGQ/buhdBqPxlk3Gion2IMDQIz3kJe/ZS34I7uHkmD7VSQVgYDNyIAwsNCgfXGXoOBPjP9DKrOCAogA2etGTmTHAMcFwFZye7wS5QlVHGjoEw4A2qPCUBZ6AzNcQ5Q/YYRdO+YB1U3dsDwypLio4FJ3ECryIzWz6Cm3NgTRHN8HiPF6eHAGSbAdh8feFZkB7krzaHE9h2o85sDsiAbkIsXQMN+e2CtGyF0kzdwXCgU5++D/ouLQFV4OEU/g2Q/iNuIPNaKkQflAWBqexxGjhLDVUcL6IwSQN3SGVChe6FJg9dckCx6D1QBliDZLIAxo7eA8eyv4KE0BJqTrHkZvnL9DJKn+Twmt0NsGGHZy2Dn3kQYfsQ53Hh4/r4RNGz8AIpdzKEuaAF0RC2E57MmQgE3ATjuM/CPiANW7AqSfQJQ5vk362eQKmd3JrmXsoSRocpNIMnbB9zbceDIWUPmuHFQNMkISqa9DpUvNK6YDpW2s8DfwBK48WFQnhMCgzUBoLy0BrRVe5P0NWjPLdKUsJiR1tR1wGp8IeZwMgx/SrgRvjxuAziNcwLvyathLOcJHLflhRDYGRYFrNET2rJ5yvPLoas0tOj/oL8UpC4JHyTSU+6MNCS4gvKoAB5WiKG+MAQSg0WwLXQ/ZJ3xhao0FxB5hYCbUwAEfhEF3Td8QP2dAOQnPwFlxgrolUVq9TPoaX+ZB2nLc2Gk6awj1MU78HZZwJMid2Byb550JQwVO0NfxlJgdz14vWKeRAiK6DlQF28PLZdcoLNcBIO92bb6GTQ8Q/13RURT6tlH2gvXMlITLYD6uI+gp2ozdF0VQXumM6ivCqGvahM8kPiDItkeGo8tB025GFQ3xFrSr06zI3/4yde7oN7m0sWk5eKWDqK5JWJQvAHac9ygq3Adr9gTNNc3QG85rzPfHe5/7wDtPwuhp/Zz6CjyhaZzwi6ivfetHdH/oP77+3PJQOsuRnqkQdCa4wWqyx6gyecpL64GTaEX7ycXUJz4GJp1B4O0X/Hg0Xp1tFV+8Ei1k6c5coHofxBrrzQinbKYo0SVJ+wn6iurGHlY5gY911aDJnMFaHXXiDp9GQyvtKfUA9QFTtBZ7gPdit0tpFd9OpwwFmlA9D/o9yNLDpxIKmI8PMnNSNtviCLVpYTITzrXEGWaq4qos0WgOPdpCenIF+eRrurjB4k0PXopYZG6gMg/D/gNBUxhAbSAmKMAAAAASUVORK5CYII="  />
              <a href=" " rel="noreferrer" style="color:#ADB3B9;" target="_blank">豫公网安备41010702003476</a >
            </div>
            <div></div>
            <div></div>
            <!-- <div class="container">
              <div>
                <span> 企业邮箱 <span>hnppcjszy@163.com</span> </span>
                <span> 邮政编码 <span>450001</span> </span>
              </div>
              <div class="bottom">
                <span style="width: 21rem">
                  线上平台咨询 <span>0371-67579156</span>
                </span>

                <span>
                  单位地址
                  <span class="add"
                    >中国河南省郑州市高新技术开发区翠竹街6号</span
                  >
                </span>
              </div>
            </div>
            <div class="guanzu">
              <img
                style="width: 6.25rem; margin-bottom: 0.375rem"
                src="../assets/images/GzH.jpg"
                alt=""
              />
              <br />

              关注微信公众号
            </div> -->
          </div>
        </div>
        <!-- <div class="footer3">
          <a href="https://beian.miit.gov.cn/">豫ICP备18016738号-1</a>
          &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span style="width: 20.75rem">
            技术支持： 河南八六三软件股份有限公司
          </span>
        </div> -->
      </el-footer>
    </el-container>
    <Login ref="login" @success="LoginSuccess" />
    <div class="sidebar">
      <Sidebar
        ref="Sidebar"
        @OpenLogin="OpenLogin"
        @toRegister="toRegister"
        @OpenAiDialog="openAi"
        @Logout="Logout"
      />
    </div>
    <AiDialog ref="AiDialogRef" />
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "../components/Sidebar";
import Login from "../components/Login";
import AiDialog from "../components/AiDialog";
import Footer from "../components/Footer";
import { library, imgcommonUrl,WechatLogin } from "@/api/url";
import { postAction,getAction } from "@/api/api";

export default {
  name: "Home",
  components: { Login, Footer, Sidebar, AiDialog },
  data() {
    return {
      input3: "",
      RealName: "",
      ShowTrue: 0,
      paths: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "精选成果库",
          path: "/jx",
        },
        {
          name: "技术成果库",
          path: "/fruit",
        },
        {
          name: "技术需求库",
          path: "/demand",
        },
        {
          name: "高层次人才库",
          path: "/talent",
        },
        {
          name: "创新平台",
          path: "/Organization",
        },
        {
          name: "科技活动",
          path: "/activity",
        },
        {
          name: "云展厅",
          path: "/CloudShow",
        },
       
        //   {
        //   name: "政策体检",
        //   path: "/qitj",
        // },
        //  {
        //   name: "创新地图",
        //   path: "/NewMap",
        // },
        {
          name: "特色服务",
          path: "",
        },
        // {
        //   name: "高校",
        //   path: "/school",
        // },
      
        // {
        //   name: "公式鉴证",
        //   path: "/AboutPublicity",
        // }, 
        // {
        //   name: "流程图",
        //   path: "/flowChart",
        // },
        //  {
        //  {
        //   name: "成果中关村转化郑洛新",
        //   path: "",
        // },
      ],
      nowFocus: 0, //点击的focus
      nowFocuss: 0, //移入的focus
      NowPath: false,
    };
  },
  created() {
    this.nowFocus =
      localStorage.getItem("NowIndex") == null
        ? 0
        : localStorage.getItem("NowIndex");
    this.nowFocuss = this.nowFocus;
    this.LoginSuccess(1);
    
    var location = window.location.href;

    this.NowPath = location.indexOf("/Assume") !== -1 ? true : false;
    this.isRegister = location.indexOf("/Register") !== -1 ? true : false;
    // vm.NowPath = e == "Assume" ? true : false;
    // vm.isRegister = e == "Register" ? true : false;
  },
  watch: {
    $route(to, from, next) {
      this.NowPath = to.path == "/Assume" ? true : false;
      this.isRegister = to.path == "/Register" ? true : false;
    },
  },
  mounted() {
    this.$bus.$on("ChangeFocus", (e) => {
      this.nowFocus = e;
      this.nowFocuss = e;
    });
  },
  methods: {
    FocusNow(n, i) {
      if (i.path !== "") {
        this.nowFocus = n;
        localStorage.setItem("NowIndex", this.nowFocus);
        this.$router.push(i.path);
      } else {
        this.nowFocus = n;
      }
    },
    isShowTrue(nowFocus, nowFocuss) {
      this.ShowTrue = 0;
      this.nowFocuss = nowFocus;
    },
    showSpecialList(i, n) {
      this.nowFocus = n;
      if (n == "8") {
        // this.nowFocus = n;
        this.ShowTrue = 1;
      } else if (n == "9"){
        this.ShowTrue = 2;
      }
    },
    ToSearch() {
      this.$router.push({ path: "/SearchData", query: { value: this.input3 } });
    },
    toIndex() {
      this.$router.push({ path: "/" });
    },
    // 登录
    OpenLogin() {
      this.$refs.login.show();
    },

    // 注册
    toRegister() {
      this.$router.push("/Register");
    },
    // 打开科创ai弹窗
    openAi(){
      console.log("4r4454")
      this.$refs.AiDialogRef.show()
    },
    //登陆成功
    LoginSuccess(value) {
      let code = this.getQueryString("code");
      if(code != null && code !="" && value==1)
      {
      //this.isWeChatLogin()
      let data = {
        action: "Get_UserInfoWX",
         codeInfo:code,
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        if(res.ID ==-1)
        {
          localStorage.setItem("UserInfo", JSON.stringify(res));
          this.$router.push("/weChatLogin");
        }
        else
        {
        this.RealName = res.RealName;
        let ID = res.ID == 0 ? "" : res.ID;
        localStorage.setItem("RealName", res.RealName);
        localStorage.setItem("RealID", ID);
        this.$refs.Sidebar.isLogin();
        }
        
      });
      // let data = {
      //   action: "Get_UserInfoWX",
      //   codeInfo:code,
      // };
      // postAction(library, this.$qs.stringify(data)).then((res) => {
       
      //   this.RealName = res.RealName;
      //   let ID = res.ID == 0 ? "" : res.ID;
      //   localStorage.setItem("RealName", res.RealName);
      //   localStorage.setItem("RealID", ID);
      //   this.$refs.Sidebar.isLogin();
      
        
      // });
      }
      else
      {
      let data = {
        action: "Get_UserInfo",
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        this.RealName = res.RealName;
        let ID = res.ID == 0 ? "" : res.ID;
        localStorage.setItem("RealName", res.RealName);
        localStorage.setItem("RealID", ID);
        this.$refs.Sidebar.isLogin();
      });

      }
  
    },
    isWeChatLogin() {
      let code = this.getQueryString("code");
      let data = {
        action: "Weixinaccess_token",
        code: code,
      };
      getAction(WechatLogin, data).then((res) => {
        if (res.status == 1) {
          this.getwxuserinfo(res.access_token, res.openid);
        }
      });
    },
    getwxuserinfo(token, openid) {
      let data = {
        action: "getweixinuserinfo",
        openid: openid,
		accesstoken: token,
      };
      getAction(WechatLogin, data).then((res) => {
        if (res.status == 10) {
          localStorage.setItem("UserInfo", JSON.stringify(res));
          this.$router.push("/weChatLogin");
        } else if (res.status == 1) {
          localStorage.setItem("UserInfo1", JSON.stringify(res));
          var wxuserinfoupdate = res;
          wxuserinfoupdate.action = "bangdingwxuserinfo";
          getAction(WechatLogin, wxuserinfoupdate).then((res) => {});
        }
        // window.location.reload();
      });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //退出
    Logout() {
      let data = {
        action: "Log_Out",
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        this.LoginSuccess(0);
        setTimeout(() => {
          this.$bus.$emit("LoginSuccess", true);
        }, 200);
      });
    },
    toManage() {
      window.parent.location.href = imgcommonUrl + "/Manage/Index.aspx";
    },
    //跳转关于我们页面
    goAboutUs() {
      this.$router.push("/aboutUs");
    },
     getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>
<style lang='scss' scoped>
.sidebar {
  width: 5rem;
  height: 37rem;
  position: fixed;
  right: 0;
  bottom: 2rem;
  
}
.el-header {
  padding: 0;
  height: 14.875rem !important;
  ul {
    height: 6.25rem;
    background: linear-gradient(270deg, #005cce 0%, #409aff 100%);
    padding: 0 16.25rem;
    font-size: 1.375rem;
    display: flex;
    justify-content: space-around;
    line-height: 6.25rem;
    margin: 0;
    li {
      color: #fff;
      padding: 0 1.0625rem;
      cursor: pointer;

    }
  
  }
  li:nth-child(2){
    cursor: pointer;
  font-weight:bold;
  background-image: linear-gradient(to bottom,#fff, orange);
  -webkit-background-clip: text;
  color: transparent;
  .nw{
    width: 1rem;
   margin-top: 1.5rem;
float: right;
img{
  width: 1.7rem;
  height: 0.9rem;
}
}
}
li:nth-child(2):hover {
    background: rgba(255, 255, 255, 0.2);
  font-weight:bold;

  color: white;
}
  
}
.isResigters {
  height: 26.375rem !important;
}
.Header {
  background-image: url("../assets/Home/组 20@2x.png");
  height: 8.75rem;
  background-size: 100% 100%;
  div {
    padding-top: 1.875rem;
    img {
      width: 33.5625rem;
      height: auto;
    }
    /deep/ .el-input-group__append {
      background: #5599ff;
      color: #fff;
      border: 0.0625rem solid #5599ff;
    }
  }
}

.el-footer {
  height: 20rem !important;
  padding: 0;
  margin: 0;

  background: #222a3d;
  .footer1 {
    height: 15.875rem;
    background: #202D42 ;
.about{
  width: 10rem;
  height: 10rem;
  .tit{
    color: white;
    margin-bottom:0.3rem;
  }
  a{
    color: #ADB3B9 ;
    font-size:0.875rem;
  }
}
.work{
  width: 30rem;
  height: 10rem;
  text-align: left;
  .tit{
    color: white;
    margin-bottom:0.3rem;
  }
  div{
    color: #ADB3B9 ;
    font-size:0.875rem;
  }
}
    // div {
    //   padding-top: 1.25rem;
    //   img {
    //     width: 32rem;
    //   }
    //   div {
    //     margin-top: -2rem;
    //     font-size: 1rem;
    //     color: rgba(255, 255, 255, 0.5);
    //     span {
    //       cursor: pointer;
    //       margin: 0 .9375rem;
    //     }
    //     a {
    //       font-size: 1rem;
    //       color: rgba(255, 255, 255, 0.5);
    //     }
    //   }
    // }
  }
  .footer2 {
    .Globalcontainer {
      font-size: 0.875rem;
      color: #ffffff80;
      height: auto;
    //  padding: 3.5625rem 0 3.1875rem 0;
      // border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.2);
      // .container {
      //   height: 5.0625rem;
      //   width: 52.1875rem;
      //   text-align: left;
      //   display: flex;
      //   div {
      //     display: flex;
      //     flex-wrap: wrap;
      //     align-items: center;
      //     span {
      //       min-width: 15.25rem;
      //       display: inline-block;
      //       span {
      //         display: inline;
      //         font-size: 1.25rem;
      //         color: #fff;
      //         font-weight: 500;
      //         margin-left: 1.25rem;
      //       }
      //     }
      //   }
      // }
      // .guanzu{
      //   margin-right: 1.875rem;
      // }
    }
  }
  // .footer3 {
  //   font-size: 1rem;
  //   font-family: PingFangSC-Regular;
  //   height:4.1875rem;
  //   line-height: 4.1875rem;
  //   color: #ffffff;
  //   opacity: 0.5;
  //   a {
  //     color: #ffffff;
  //   }
  // }
}
.isFocus {
  height: 6.25rem;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  position: relative;
}
.RightContent {
  display: flex;
  font-size: 0.875rem;
  width: 600px;
  color: #fff;
  align-items: center;
  padding: 0 !important;
  h3 {
    margin-left: 3.125rem;
  }
  div {
    padding: 0;
  }
  span {
    width: 8.75rem;
    margin-left: 1.25rem;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .RegisterBtn {
    background: transparent;
    border: 0.0625rem solid #ffffff;
    border-radius: 0.3125rem;
  }
}
.isAssume {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  .Header,
  ul {
    background: transparent;
  }
}
.RegisterPage {
  height: 26.375rem;
  background: url("../assets/images/Header.png");
  background-size: 100% 100%;
}
.specialList {
  width: 7.6875rem;
  height: 20rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
  position: absolute;
  left: 0;
  z-index: 99;
  top: 6.125rem;
  a {
    text-decoration: none;
    color: #333;
    display: block;
    font-size: 1.125rem;
    line-height: 4rem;
  }
  a:hover {
    background: #f6f6f6;
  }
}
.specialList1 {
  width: 15.7875rem;
  height: 28rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
  position: absolute;
  left: 0;
  z-index: 99;
  top: 6.125rem;
  a {
    text-decoration: none;
    color: #333;
    display: block;
    font-size: 1.125rem;
    line-height: 4rem;
  }
  a:hover {
    background: #f6f6f6;
  }
}
.add {
  color: #fff;
  font-size: 1.25rem;
}
@media (max-width: 1400px) {
  .Header {
    // div {
    //   width: 100%;
    //   box-sizing: border-box;
    //   padding-left: 1.25rem;
    //   padding-right: 1.25rem;
      // div {
      //   width: auto;
      // }
    // }
  }
}
.ishad{
  font-size:1.5rem;
  font-weight: bold;
  font-family: Microsoft YaHei;
}
.guanyu{
  margin: 0 !important;
}

</style>
